module.exports = __webpack_public_path__ + "static/caitlin-baird-97ade5c687dde82e8ef816ca6e2c3073.jpg";